import { Component, Input } from '@angular/core';
import { ControlContainer, FormControl, FormGroupDirective, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { InputFormFieldComponent } from '../fields/input-form-field/input-form-field.component';
import { SelectFormFieldComponent } from '../fields/select-form-field/select-form-field.component';
import { TextareaFormFieldComponent } from '../fields/textarea-form-field/textarea-form-field.component';
import { DatepickerFormFieldComponent } from '../fields/datepicker-form-field/datepicker-form-field.component';
import { DropdownTypeEnum } from 'app/shared/enums/dropdowns.enum';
import { ConfigurationSelectFormFieldComponent } from '../fields/configuration-select-form-field/configuration-select-form-field.component';
import { CheckboxFormFieldComponent } from '../fields/checkbox-form-field/checkbox-form-field.component';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-product-details-eparts-form',
  standalone: true,
  imports: [
    ReactiveFormsModule,
    TextareaFormFieldComponent,
    SelectFormFieldComponent,
    InputFormFieldComponent,
    TextareaFormFieldComponent,
    CheckboxFormFieldComponent,
    DatepickerFormFieldComponent,
    TranslateModule,
    ConfigurationSelectFormFieldComponent,
    CommonModule
  ],
  templateUrl: './product-details-eparts-form.component.html',
  styleUrl: './product-details-eparts-form.component.scss',
  viewProviders: [{ provide: ControlContainer, useExisting: FormGroupDirective }],
})
export class ProductDetailsEpartsFormComponent {
  @Input() viewMode!: boolean;

  form: any;
  datepickerMaxDate: Date = new Date();
  dropdownFamilyNameType = DropdownTypeEnum.FAMILY_NAME;
  dropdownFamilyVariantType = DropdownTypeEnum.FAMILY_VARIANT;
  dropdownRootCause = DropdownTypeEnum.ROOT_CAUSE;

  constructor(
    public mainForm: FormGroupDirective,
  ) { }

  ngOnInit(): void {
    this.createForm();
  }

  createForm() {
    this.form = this.mainForm.form;

    this.form.addControl('epartMaterialNumber', new FormControl(null, []));
    this.form.addControl('epartDescription', new FormControl(null, []));
    this.form.addControl('familyName', new FormControl(null, []));
    this.form.addControl('familyVariant', new FormControl(null, []));
    this.form.addControl('reportedIssueDescription', new FormControl(null, []));
    this.form.addControl('epartBuildDate', new FormControl(null, []));
    this.form.addControl('internalInvestigationNumber', new FormControl(null, []));
    this.form.addControl('epartReceivedDate', new FormControl(null, []));
    this.form.addControl('rootCause', new FormControl(null, []));
    this.form.addControl('epartSerialNumber', new FormControl(null, []));
    this.form.addControl('nonConformanceDate', new FormControl(null, []));
    this.form.addControl('reportUploaded', new FormControl(false, []));
    this.form.addControl('additionalEpartsInfo', new FormControl(null, []));
    this.form.addControl('rootCause', new FormControl(null, []));
    this.form.addControl('assignedInvestigatorDate', new FormControl(null, []));
  }

}
